// A consistent empty state: an icon, a serif title, one line of body copy and (optionally) the
// single action that fills the emptiness.
import "./config";
import { View } from "tamagui";
import { Icon, type IconName } from "./Icon";
import { Rise } from "./layout";
import { Body, Heading } from "./text";

export interface EmptyStateProps {
  icon: IconName;
  title: string;
  body?: string | undefined;
  action?: React.ReactNode;
  /** `status` for an emptiness that appears on its own (offline) and should be announced. */
  role?: "status" | "alert";
}

export function EmptyState({
  icon,
  title,
  body,
  action,
  role,
}: EmptyStateProps): React.JSX.Element {
  return (
    <Rise
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(role === undefined ? {} : { role })}
      alignItems="center"
      gap="3"
      paddingVertical="7"
      paddingHorizontal="5"
      borderWidth="var(--borderW)"
      borderStyle="dashed"
      borderColor="lineStrong"
      borderRadius="3"
    >
      <View aria-hidden>
        <Icon name={icon} size={30} tone="textFaint" />
      </View>
      <Heading render="h2" textAlign="center">
        {title}
      </Heading>
      {body === undefined ? null : (
        <Body tone="dim" size="small" center maxWidth={300} lineHeight="4">
          {body}
        </Body>
      )}
      {action === undefined ? null : <View marginTop="1">{action}</View>}
    </Rise>
  );
}
